export default __webpack_public_path__ + "static/media/delete.7e5cf35f.svg";